module.exports = __webpack_public_path__ + "img/cloth_g1_sleeve_09.aba3b2b9.svg";